import { render, staticRenderFns } from "./BaseWrapper.vue?vue&type=template&id=896cd50a&scoped=true"
import script from "./BaseWrapper.vue?vue&type=script&lang=js"
export * from "./BaseWrapper.vue?vue&type=script&lang=js"
import style0 from "./BaseWrapper.vue?vue&type=style&index=0&id=896cd50a&prod&lang=scss&scoped=true"
import style1 from "./BaseWrapper.vue?vue&type=style&index=1&id=896cd50a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896cd50a",
  null
  
)

export default component.exports